import React, { useState, useMemo, useCallback } from 'react'
import { List, Dialog, Tabs, Tab } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { additionalStyleProps } from './helpers'
import { useIntl } from 'react-intl'
import EmptySubscribersList from './EmptySubscribersList'
import { FormattedMessage } from 'react-intl'
import { tabs, flagsName, REPORTS, LIKES } from './constants'
import MetricsDialogHeader from './metricsDialogHeader'
import Subscriber from './Subscriber'
import SubscribersDetail from './SubscriberDetail'

const useStyles = makeStyles((theme) => ({
  subtitlesButtonStyle: {
    background: '#f2f2f2',
    borderRadius: '25px',
    fontSize: '13px',
    textTransform: 'capitalize',
  },
  subTitleStyle: {
    color: '#a8a8a8',
    padding: ' 0 2rem',
    fontSize: 'smaller',
    minWidth: '345px',
    overflow: 'hidden !important',
  },
  selectedTab: {
    backgroundColor: 'white',
    borderRadius: '2.8rem',
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.12)',
    color: '#0073b1',
    fontWeight: 'bold',
    lineHeight: '1.14',
    cursor: 'not-allowed',
    pointerEvents: 'none',
  },
  indicator: {
    backgroundColor: 'transparent',
  },
  MuiTabsFlexContainer: {
    padding: '2px',
  },
  tabsWrapperStyle: {
    borderRadius: '25px',
    backgroundColor: '#f2f2f2',
    color: '#a8a8a8',
    padding: '0',
    margin: '1rem',
  },
}))

const SubscribersList = ({
  onClose,
  openSubscribersDetail,
  subTitles,
  tabDetail,
  title,
  subscribersCount,
  flagSubTitles,
  customStyleForUsersList,
  openModal,
  subscriberData,
  handleOpenSubscribersDetail,
  handleCloseSubscribersDetail,
  tabTitles,
}) => {
  const classes = useStyles()
  const { formatMessage } = useIntl()
  let selectedTitleValue =
    subTitles && tabDetail[LIKES]
      ? tabDetail[LIKES].liked
      : tabDetail[subTitles[0].value] && tabDetail[subTitles[0].value]
  const [subscribersList, setSubscribersList] = useState(selectedTitleValue)
  const [value, setValue] = useState(0)
  const [selectedTabName, setSelectedTabName] = useState(subTitles[0].name)
  const handleChange = (event, newValue) => setValue(newValue)
  let tabsName
  switch (tabTitles) {
    case tabs['DeliveryRate']:
      tabsName = formatMessage({ id: `metrics.${subTitles[0].value}.title` })
      break
    case tabs['UserReaction']:
      tabsName = formatMessage({ id: 'metrics.reaction.title' })
      break
    case tabs['Listen(TTS)']:
      tabsName = formatMessage({ id: 'metrics.listen.title' })
      break
    case tabs['MediaOpened']:
      tabsName = formatMessage({ id: 'metrics.media.title' })
      break
    case tabs['ViewRate']:
      tabsName = formatMessage({ id: 'metrics.view.title' })
      break
    default:
      break
  }
  const getEmptyMessage = useCallback(
    (selectedTabName) => {
      switch (selectedTabName) {
        case 'Viewed Details':
          return formatMessage({ id: 'metrics.read.empty.message' })
        case 'Viewed in Feed':
          return formatMessage({ id: 'metrics.feed.read.empty.message' })

        case 'Fully Listened':
          return formatMessage({ id: 'metrics.fully.listened.empty.message' })
        case 'Partially Listened':
          return formatMessage({
            id: 'metrics.partialy.listened.empty.message',
          })
        default:
          return ''
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedTabName],
  )

  const handleSubscriber = (value, tabsName) => {
    tabsName && setSelectedTabName(tabsName)
    if (subTitles) {
      value && setSubscribersList(tabDetail[value])
    }
    if (flagSubTitles) {
      value && setSubscribersList(tabDetail[REPORTS][flagsName[tabsName]])
    }
  }
  const remainedSubTitles = [
    formatMessage({ id: 'metrics.full.listened' }),
    formatMessage({ id: 'metrics.listened' }),
    formatMessage({ id: 'metrics.read' }),
    formatMessage({ id: 'metrics.feed.read' }),
  ]
  let getSubscribersCount = useMemo(() => {
    return Object.values(subscribersList).length
  }, [subscribersList])
  return (
    <Dialog
      open={openModal}
      aria-labelledby="subscribers-list"
      maxWidth={false}
    >
      <MetricsDialogHeader
        title={tabsName}
        iconName="close"
        handleClose={onClose}
      />

      <div className={classes.subTitleStyle}>
        <FormattedMessage
          id="metrics.subscribers"
          values={{ count: getSubscribersCount }}
        />
      </div>
      <div className={classes.tabsWrapperStyle}>
        {subTitles.length > 1 && (
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
            classes={{ indicator: classes.indicator }}
            className={classes.MuiTabsFlexContainer}
          >
            {subTitles.map((item, index) =>
              remainedSubTitles.includes(item.name) ? (
                // to do Missing "key" prop for element in array
                <Tab
                  label={item.name}
                  onClick={() => handleSubscriber(item.value, item.name)}
                  {...additionalStyleProps(index)}
                  className={classes.subtitlesButtonStyle}
                  classes={{ selected: classes.selectedTab }}
                />
              ) : null,
            )}
          </Tabs>
        )}
      </div>
      <List className={customStyleForUsersList}>
        {Object.values(subscribersList).length ? (
          subscribersList.map((item, index) => (
            <Subscriber
              item={item}
              handleOpenSubscribersDetail={handleOpenSubscribersDetail}
              key={`subscribersList-${index}`}
              lastSeen={tabTitles === tabs['DeliveryRate']}
            />
          ))
        ) : (
          <EmptySubscribersList message={getEmptyMessage(selectedTabName)} />
        )}
      </List>
      <SubscribersDetail
        open={openSubscribersDetail}
        subscriberData={subscriberData}
        handleCloseModal={handleCloseSubscribersDetail}
      />
    </Dialog>
  )
}

export default SubscribersList
